// Functions DGA - https://prelive-dga0.pragmaticplaylive.net/dgaAPI.js
// Documentacao Pragmatic play - https://marketing.pragmaticplay.com/index.php/s/A5Ck3ZPtLOw0UpV#pdfviewer
//? Solicitar senha
//? Pagina 169 - Integracao com DGA
const dga = {
  data: () => {
    return {
      websocket: null,
      wsUri: null,
      tableId: null,
      casinoId: null,
      tryToConnect: true,
      tableKey: [],
      tableData: {},
    };
  },
  methods: {
    setCasinoId(id) {
      this.casinoId = id;
    },
    // public
    connect: function(wsUri, casinoId, tableId) {
      var self = this;
      self.tryToConnect = true;
      self.wsUri = wsUri;
      // console.log("connecting to " + "wss://" + wsUri + "/ws");
      if (self.websocket !== null && self.websocket.readyState !== 3) {
        self.websocket.close();
        // console.log("Socket open closing it");
      }
      self.websocket = new WebSocket("wss://" + wsUri + "/ws");
      self.websocket.onopen = function(evt) {
        self.onWsOpen(evt, casinoId, tableId);
      };
      // self.websocket.onclose = function(evt) {
      //   self.onWsClose(evt);
      // };
      self.websocket.onmessage = function(evt) {
        self.onWsMessage(evt);
      };
      // self.websocket.onerror = function(evt) {
      //   self.onWsError(evt);
      // };
      if (tableId) {
        self.tableId = tableId;
      }
      self.casinoId = casinoId;
    },
    // public
    onMessage: function(data) {
      const self = this;
      // to fill
      let subscribe = data.tableKey;
      if (subscribe != null) {
        data.tableKey.forEach((element) => {
          self.subscribe(this.casinoId, element);
        });
      } else if (data.tableId) {
        this.tableData = { ...this.tableData };
        this.tableData[data.tableId] = {
          dealer: data.dealer.name,
          tableId: data.tableId,
          tableImage: data.tableImage,
          totalSeatedPlayers: data.totalSeatedPlayers,
          tableName: data.tableName,
          tableOpen: data.tableOpen,
          tableType: data.tableType,
          ...data.tableLimits,
        };
        // console.log("tableData: ", this.tableData);
      }
    },
    // public
    onConnect: function() {
      var self = this;
      // to fill
      return self.available(this.casinoId);
    },
    // public
    disconnect: function() {
      var self = this;
      self.tryToConnect = false;

      if (self && self.websocket) {
        self.websocket.close();
      }
      // console.log('Disconnected');
    },
    // public
    subscribe: function(casinoId, tableId, currency) {
      var subscribeMessage = {
        type: "subscribe",
        key: tableId,
        casinoId: casinoId,
        currency: currency,
      };
      // console.log('subscribing' + tableId);

      var self = this;
      // console.log('Subscribing ' + tableId);
      var jsonSub = JSON.stringify(subscribeMessage);
      self.doWsSend(jsonSub);
    },
    // public
    available: function(casinoId) {
      var availableMessage = {
        type: "available",
        casinoId: casinoId,
      };

      var self = this;
      // console.log('Subscribing ' + tableId);
      var jsonSub = JSON.stringify(availableMessage);
      self.doWsSend(jsonSub);
    },
    onWsOpen: function() {
      var self = this;

      // console.log(evt.data);
      if (self.onConnect != null) {
        self.onConnect();
      }

      // console.log("Connected to wss server");
      if (self.tableId) {
        self.subscribe(self.casinoId, self.tableId);
      }
    },
    // onWsClose: function() {
    //   // console.log("DISCONNECTED");
    //   var self = this;
    //   if (self.tryToConnect === true) {
    //     // console.log("RECONNECTING");
    //     self.connect(self.wsUri, self.casinoId, self.tableId);
    //   }
    // },
    onWsMessage: function(evt) {
      var self = this;
      var data = JSON.parse(evt.data);
      // console.log(data);
      if (self.onMessage != null) {
        self.onMessage(data);
      }
    },
    // onWsError: function() {
    //   console.log("ERROR: " + evt.data);
    // },
    ping: function() {
      var self = this;
      var pingMessage = {
        type: "ping",
        pingTime: Date.now().toString(),
      };
      var jsonSub = JSON.stringify(pingMessage);
      self.doWsSend(jsonSub);
    },
    doWsSend: function(message) {
      var self = this;
      // console.log("SENT: " + message);
      self.websocket.send(message);
    },
  },
};

export default dga;
